import { render, staticRenderFns } from "./BtnExcluirAlerta.vue?vue&type=template&id=5eee23da&"
import script from "./BtnExcluirAlerta.vue?vue&type=script&lang=js&"
export * from "./BtnExcluirAlerta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports